var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2695",
    "data-name": "Rectangle 2695",
    width: 28,
    height: 28,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_FILL1_wght400_GRAD0_opsz24",
    d: "M15.427,23.759l-5.811,3.5a1.272,1.272,0,0,1-.805.21,1.353,1.353,0,0,1-.735-.28,1.68,1.68,0,0,1-.49-.612,1.226,1.226,0,0,1-.07-.823l1.54-6.616L3.91,14.692a1.338,1.338,0,0,1-.437-.718,1.388,1.388,0,0,1,.052-.787,1.5,1.5,0,0,1,.42-.63,1.455,1.455,0,0,1,.77-.315l6.792-.6,2.626-6.231a1.256,1.256,0,0,1,.543-.63,1.454,1.454,0,0,1,1.505,0,1.258,1.258,0,0,1,.542.63l2.626,6.231,6.792.6a1.455,1.455,0,0,1,.77.315,1.5,1.5,0,0,1,.42.63,1.4,1.4,0,0,1,.053.787,1.346,1.346,0,0,1-.438.718L21.8,19.138l1.54,6.616a1.226,1.226,0,0,1-.07.823,1.68,1.68,0,0,1-.49.612,1.353,1.353,0,0,1-.735.28,1.272,1.272,0,0,1-.805-.21Z",
    transform: "translate(-1.428 -2.475)",
    fill: "#222227"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.856dfcbd43eaf0fcb8eedd077223b4e0.svg";
export { ForwardRef as ReactComponent };